import { ListOrderTypesQuery } from "@saleor/graphql";

export const getProductGroup = (productGroup, label) => {
  const list =
    productGroup?.dropdownListMaterialGroup1.map(e => ({
      label: `${e.materialGroup1}: ${e.materialGroup1Desc}`,
      value: e.materialGroup1
    })) || [];
  if (list.length > 1) {
    list.unshift({
      label,
      value: "All"
    });
  }
  return list;
};

export const getOrderTypes = (
  orderTypesList: ListOrderTypesQuery["listOrderTypes"],
  bu: string
) => {
  let typesList = [];
  if (bu && orderTypesList) {
    typesList = orderTypesList?.filter(type => type?.bu === bu);
    if (typesList?.length > 1) {
      typesList.unshift({
        label: "ALL",
        value: "All"
      });
    }
  }
  return typesList;
};
